import { AssignedDashboardProps } from "@/interfaces/dashboard_types";
import { useEffect } from "react";
import { usePreferences } from "@/hooks/usePreference";
import { useAuth } from "@/App";
import { DashboardFactory } from "../Utils/DashboardFactory";

// Dashboard that is used for all roles. Sections are different depending on the role
// I can do a factory function to return the correct container based on the role
export function AssignedDashboardContainer(
    { announcements, sorted_tasks, sorted_projects, sorted_submittals, sorted_rfis, isNewCard, markAsSeen, contactUs, role, sorted_invoices, sorted_assignments, sorted_bids }: AssignedDashboardProps
) {
    const { user } = useAuth()
    
    const { 
        getUserPreferences,
        preferences
    } = usePreferences(user ?? null)

    useEffect(() => {
        getUserPreferences()
    }, [getUserPreferences, user])

    return (
        <div className="flex flex-col py-2 pr-2 ml-2">

            {DashboardFactory(role, {
                sorted_tasks,
                sorted_assignments,
                sorted_projects,
                sorted_submittals,
                sorted_rfis,
                sorted_bids,
                preferences,
                isNewCard,
                markAsSeen,
                sorted_invoices,
                contactUs,
                announcements
            })}

        </div>
    )
}

